import Navbar from "../../components/shared/Navbar";
import Footer from "../../components/shared/Footer";
import BreadCrumbCompany from "../../components/aboutCompany/BreadCrumbCompany";
import Hero from "../../components/aboutCompany/Hero";
import Content from "../../components/aboutCompany/Content";
import VisiMisi from "../../components/aboutCompany/VisiMisi";
import RightBar from "../../components/shared/RightBar";
import { Helmet } from "react-helmet";

export default function AboutCompany() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Tentang kami - BPR Palu Anugerah</title>
                <meta name="description" content="Pelajari lebih lanjut tentang BPR Palu Anugerah, visi misi kami, dan tim yang berdedikasi untuk melayani kebutuhan finansial Anda." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Tentang kami - BPR Palu Anugerah" />
                <meta property="og:description" content="Pelajari lebih lanjut tentang BPR Palu Anugerah, visi misi kami, dan tim yang berdedikasi untuk melayani kebutuhan finansial Anda." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <Hero></Hero>
                <BreadCrumbCompany></BreadCrumbCompany>
                <Content></Content>
                <VisiMisi></VisiMisi>
            </main>
            <Footer />
        </div>
    )
}